// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V1TW","title":"styles_title__on_Xg"};